module.exports = __webpack_public_path__ + "img/140.8.7748c48c.png";